// src/redux/PublicCity/publicCitySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { searchPublicCitiesAPI } from "./publicCityApi";

// GET /public/cities/search?search=
export const searchPublicCities = createAsyncThunk(
  "publicCity/searchPublicCities",
  async (search, { rejectWithValue }) => {
    try {
      const response = await searchPublicCitiesAPI(search);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to search cities"
      );
    }
  }
);

// ---------- Initial State ----------
const initialState = {
  searchCities: { data: [], loading: false, error: null },
};

// ---------- Slice ----------
const publicCitySlice = createSlice({
  name: "publicCity",
  initialState,
  reducers: {
    clearSearchCities: (state) => {
      state.searchCities.data = [];
      state.searchCities.error = null;
    },
  },
  extraReducers: (builder) => {
    // ---------- Search Cities ----------
    builder
      .addCase(searchPublicCities.pending, (state) => {
        state.searchCities.loading = true;
        state.searchCities.error = null;
      })
      .addCase(searchPublicCities.fulfilled, (state, action) => {
        state.searchCities.loading = false;
        state.searchCities.data = action.payload?.data || action.payload || [];
      })
      .addCase(searchPublicCities.rejected, (state, action) => {
        state.searchCities.loading = false;
        state.searchCities.error = action.payload;
      });
  },
});

export const { clearSearchCities } = publicCitySlice.actions;

export default publicCitySlice.reducer;
